import './App.css';
import FlightStatus from './components/flight-status/FlightStatus';

function App() {
  return (
    <div className="App">
      <FlightStatus/>
    </div>
  );
}

export default App;
